<template>
  <div class="page-students">
    <el-form size="small" ref="filter" inline>
      <el-form-item label="学员姓名：" prop="name">
        <el-input v-model="filter.name" placeholder="请输入学员姓名" clearable />
      </el-form-item>
      <el-form-item label="学员手机号：" prop="phone">
        <el-input v-model="filter.phone" placeholder="请输入学员手机号" clearable />
      </el-form-item>
      <el-form-item label="合格证颁发状态：" prop="qualifiedIs">
        <el-select style="width: 200px" v-model="filter.qualifiedIs" clearable="" placeholder="请选择合格证颁发状态">
          <el-option label="全部" value="" />
          <el-option v-for="(value, key) of qualifiedIsObj" :key="key" :label="value" :value="key" />
        </el-select>
      </el-form-item>
      <el-form-item label="结业证颁发状态：" prop="graduationIs">
        <el-select style="width: 200px" v-model="filter.graduationIs" clearable="" placeholder="请选择结业证颁发状态">
          <el-option label="全部" value="" />
          <el-option v-for="(value, key) of graduationIsObj" :key="key" :label="value" :value="key" />
        </el-select>
      </el-form-item>
      <el-form-item label="考场名称：" prop="testPlanName">
        <el-input v-model="filter.testPlanName" placeholder="请输入考场名称" clearable />
      </el-form-item>
      <el-form-item v-if="checkAdmin()" label="学员来源：">
        <el-select style="width: 200px" v-model="companyId" clearable filterable placeholder="请选择学员来源">
          <el-option label="全部" value="" />
          <el-option v-for="item of companyList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-card style="margin-top: 10px">
      <el-row style="margin-bottom: 10px;">
        <el-button v-if="checkAdmin()" type="primary" size="small" @click="add">添加</el-button>
        <el-button v-if="checkAdmin()" type="danger" size="small" @click="dels">批量移除</el-button>
        <div class="btns">
          <template v-if="showOperateAll || !checkAdmin()">
            <el-button size='mini' type="primary" icon="el-icon-edit" @click="dcAll(1, '合格证信息列表')">导出全部合格证信息</el-button>
            <el-button size='mini' type="primary" icon="el-icon-edit" @click="dcAll(2, '结业证信息列表')">导出全部结业证信息</el-button>
          </template>
          <template v-if="!showOperateAll && checkAdmin()">
            <el-button size='mini' type="primary" icon="el-icon-edit" @click="pldc(2)">合格证信息批量导出</el-button>
            <el-button size='mini' type="primary" icon="el-icon-edit" @click="pldc(1)">结业证书信息批量导出</el-button>
          </template>
        </div>
        <div class="btns" v-if="checkAdmin()">
          <template v-if="showOperateAll">
            <el-button size='mini' type="primary" icon="el-icon-edit" @click="plBfAll">颁发全部合格证</el-button>
            <el-button size='mini' type="primary" icon="el-icon-edit" @click="awardGraduationAll">颁发全部结业证</el-button>
          </template>
          <template v-if="!showOperateAll">
            <el-button size='mini' type="primary" icon="el-icon-edit" @click="plBf">批量颁发合格证</el-button>
            <el-button size='mini' type="primary" icon="el-icon-edit" @click="awardGraduation">批量颁发结业证书</el-button>
          </template>
        </div>
      </el-row>
      <el-table :data="studentsList" style="width: 100%" border @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" width="55" />
        <el-table-column label="用户昵称" align="center" min-width="120" prop="nickname" :formatter="fliteRData" />
        <el-table-column label="签约姓名" align="center" min-width="120" prop="contractSignName" :formatter="fliteRData" />
        <el-table-column label="签约身份证号" align="center" min-width="120" prop="contractSignIdCard" :formatter="fliteRData" />
        <el-table-column label="用户手机号" align="center" prop="phone" min-width="120">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="学员来源" align="center" prop="companyName" min-width="180" />
        <el-table-column label="教务服务方" align="center" prop="agentName" min-width="180" />
        <el-table-column label="获取方式" align="center" prop="getMode">
          <template v-slot="{ row }">
            {{getModeObj[row.getMode]}}
          </template>
        </el-table-column>
        <el-table-column label="综合评定成绩" align="center" prop="evaluationAll" min-width="160" :formatter="fliteRData" />
        <el-table-column label="考场名称" align="center" prop="testPlanName" min-width="160" :formatter="fliteRData" />
        <el-table-column label="可预约次数" align="center" prop="canAppointNum" min-width="160" />
        <el-table-column label="合格证颁发状态" align="center" prop="qualifiedIs" min-width="160">
          <template v-slot="{ row }">
            {{qualifiedIsObj[row.qualifiedIs]}}
          </template>
        </el-table-column>
        <el-table-column label="结业证颁发状态" align="center" prop="graduationIs" min-width="160">
          <template v-slot="{ row }">
            {{graduationIsObj[row.graduationIs]}}
          </template>
        </el-table-column>
        <el-table-column label="合格证套打次数" align="center" prop="qualifiedPrintNum" min-width="160" :formatter="fliteRData" />
        <el-table-column label="有效期开始时间" align="center" prop="beginDate" min-width="160" :formatter="fliteRData" />
        <el-table-column label="有效期结束时间" align="center" prop="expiryDate" min-width="160" :formatter="fliteRData" />
        <el-table-column label="添加原因" align="center" prop="addReason" min-width="160" :formatter="fliteRData" />
        <el-table-column label="备注" align="center" prop="remarks" min-width="160" :formatter="fliteRData" />
        <el-table-column label="操作时间" align="center" prop="lastUpdateDate" min-width="160" :formatter="fliteRData" />
        <el-table-column label="操作人" align="center" prop="lastUpdateName" min-width="120" :formatter="fliteRData" />
        <el-table-column align="center" label="操作" min-width="200" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" v-if="checkAdmin()" @click="handleClick('bf',row)">颁发合格证</el-button>
            <el-button type="text" v-if="checkAdmin()" :disabled="row.qualifiedIs === 1" @click="handleClick('del',row)">删除合格证</el-button>
            <el-button v-if="checkAdmin()" type="text" :disabled="row.qualifiedIs === 1" @click="handleClick('print',row)">套打合格证</el-button>
            <el-button v-if="!checkAdmin()" type="text" :disabled="row.qualifiedIs === 1 || !(applyNum > 0 && !row.isOwn)" @click="handleClick('print',row)">套打合格证</el-button>
            <el-button type="text" v-if="checkAdmin()" @click="del(row.id)">移除</el-button>
            <el-button type="text" v-if="checkAdmin()" @click="toManageExamNum(row)">调整考试次数</el-button>
            <el-button type="text" v-if="checkAdmin()" @click="toManageExamLog(row.id)">操作记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="btns b-btns" v-if="checkAdmin()">
        <template v-if="showOperateAll">
          <el-button size='mini' type="danger" icon="el-icon-edit" @click="deleteAllCer(2)">删除所有合格证</el-button>
          <el-button size='mini' type="danger" icon="el-icon-edit" @click="deleteAllCer(1)">删除所有结业证</el-button>
        </template>
        <template v-if="!showOperateAll">
          <el-button size='mini' type="danger" icon="el-icon-edit" @click="deletepl">批量删除合格证</el-button>
          <el-button size='mini' type="danger" icon="el-icon-edit" @click="delGraduation">批量删除结业证书</el-button>
        </template>
      </div>
      <el-pagination style="margin-top: 10px; text-align: center;" :current-page="filter.page" :page-sizes="[10, 20, 30, 50]" :page-size="filter.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </el-card>

    <!-- //添加学员 -->
    <AddStudent ref="addStudent" @update="handleReset" :companyId="companyId" :skuId="skuId" />
    <!-- //颁发证书 -->
    <HandleCerBf ref='dialogBfSign' :editParams='editNewParams' :studentId='studentId' :companyId="companyId" @success='getList'></HandleCerBf>
    <!-- //套打 -->
    <Print ref="print" />
    <!-- 调整考试次数 -->
    <ManageExamNum ref="manageExamNumEl" @refresh="getList" />
    <MangeExamLog ref="mangeExamLogEl" />
    <!-- 导出 -->
    <FileExport ref="FileExport" />
  </div>
</template>
<script>
import tableMixins from "@/libs/mixins/table"
import { downloadData } from '@/api/common'
import AddStudent from "./com/addStudent.vue"
import HandleCerBf from "./com/handle-cer-bf.vue";
import Print from "./com/print.vue";
import ManageExamNum from "./com/manage-exam-num.vue";
import MangeExamLog from "./com/manage-exam-log.vue";
import FileExport from "@/components/FileExport.vue";

import {
  getClassStudentList,
  delClassStudent,
  delClassStudents,
  delGraduation,
  awardGraduationAgain,
  delCertificate,
  awardQualified,
  awardQualifieds,
  delAllCertificate,
  delAllGraduation
} from '@/api/product/classManage' // 接口不一定正确
import { getAvailableCompanyList } from "@/api/product/base"
import { getAppUserInfo } from "@/api/common";

const getModeObj = {
  1: '支付购买',
  2: '赠送',
  3: '预约',
  4: '免费',
  5: '后台添加'
}
const qualifiedIsObj = {
  1: "未颁发",
  2: "已颁发"
}
const graduationIsObj = {
  1: "未颁发",
  2: "已颁发"
}

// 1pc网站 2小程序 3wap端 4ANDROIDD端 5ios端 6后台添加
const sourceTypeObj = {
  1: 'pc网站',
  2: "小程序",
  3: 'wap端',
  4: 'ANDROIDD端',
  5: "ios端",
  6: '后台添加'
}

export default {
  name: 'StudentManage',
  components: {
    AddStudent,
    HandleCerBf,
    Print,
    ManageExamNum,
    MangeExamLog,
    FileExport
  },
  mixins: [tableMixins],
  data () {
    return {
      getModeObj,
      qualifiedIsObj,
      graduationIsObj,
      sourceTypeObj,
      filter: {
        page: 1,
        limit: 10,
        name: null,
        phone: null,
        qualifiedIs: '',
        graduationIs: '',
        testPlanName: ''
      },
      total: 0,
      studentsList: [],
      checkIds: [],
      skuId: null,
      editNewParams: {},
      studentId: null,
      companyId: '',
      companyList: [],
      applyNum: 0
    }
  },
  computed: {
    showOperateAll () {
      if (this.checkIds.length === 0) {
        return true
      }
      return false
    }
  },
  created () {
    if (!this.checkAdmin()) {
      this.companyId = this.$myStore.state.user.userInfo.companyId
    } else {
      this.getCompanyList()
    }
    this.skuId = this.$attrs.skuId
    this.handleSearch()
  },
  methods: {
    handleClick (event, row) {
      if (event === 'edit') {
        this.showDialog('dialogBfSign')
        this.editNewParams = row;
        this.studentId = row.id;
      }else if (event === 'bf') {
        this.showDialog('dialogBfSign')
        this.editNewParams = row;
        this.studentId = row.id;
      } else if (event === 'print') {
        this.$refs.print.init(row.qualifiedNumber, row.id)
      } else if(event === 'del') {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCertificate([row.id]).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        });
      }
    },
    showDialog (componentName) {
      this.$refs[componentName].setOpacity(true)
    },
    async delGraduation () {
      if (!this.checkIds.length) {
        this.$message.error('请选择数据');
        return false;
      }
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await delGraduation(this.checkIds)
        this.$message.success('操作成功!')
        this.getList();
      })
    },
    async awardGraduationAgain () {
      if (!this.checkIds.length) {
        this.$message.error('请选择数据');
        return false;
      }
      const res = await awardGraduationAgain({ ids: this.checkIds.join(), classId: this.editParams.id })
      this.$message.success('操作成功!')
      this.getList();
    },
    exportBatchGraduation () {
      if (!this.checkIds.length) {
        this.$message.error('请选择数据');
        return false;
      }
      downloadData(
        `/radioweb/adm/classStudent/exportBatchGraduation`,
        {
          ids: this.checkIds.join(','),
          classId: this.editParams.id
        }
      )
    },
    handleSearch () {
      this.filter.page = 1
      this.getList()
    },
    handleReset () {
      const defaultData = this.$options.data()
      this.filter = defaultData.filter
      if (this.checkAdmin()) {
        this.companyId = ''
      }
      this.getList()
    },
    getList () {
      const params = {
        skuId: this.skuId,
        companyId: this.companyId,
        ...this.filter
      }
      if (this.chapterId !== '0') {
        params.chapterId = this.chapterId
      }
      getClassStudentList(params).then(({ code, data, message }) => {
        if (code === 0) {
          this.studentsList = data.records
          this.total = parseInt(data.total, 10)
          this.applyNum = data.current
        } else {
          this.$message.error(message)
        }
      })
    },
    // 表格选择
    handleSelectionChange (val) {
      this.checkIds = val.map(item => item.id)
    },
    add () {
      this.$refs['addStudent'].init()
    },
    del (id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await delClassStudent({ id })
        if (res.code !== 0) return
        this.$message.success('操作成功！')
        this.handleSearch()
      })
    },
    dels () {
      if (!this.checkIds.length) {
        this.$message.warning('请选择要删除的数据！')
        return
      }
      const ids = this.checkIds.join(',')
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await delClassStudents({ ids })
        if (res.code !== 0) return
        this.$message.success('操作成功！')
        this.handleSearch()
      })
    },
    toManageExamNum (row) {
      this.$refs.manageExamNumEl.init(row)
    },
    toManageExamLog (id) {
      this.$refs.mangeExamLogEl.init(id)
    },
    handleSizeChange (v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange (v) {
      this.filter.page = v
      this.getList()
    },
    async pldc (flg) {
      if (!this.checkIds.length) {
        this.$message.error('请选择数据');
        return false;
      }
      //结业证1  合格2
      if (flg === 1) {
        downloadData(
          `/product/adm/userSku/exportGraduations`,
          {ids: this.checkIds.join(',')}
        )
      } else {
        downloadData(
          `/product/adm/userSku/exportCertificates`,
          {ids: this.checkIds.join(',')}
        )
      }
    },
    // 全部导出
    async dcAll (flg, title) {
      this.$confirm('导出数据包含当前租户及下级数据，是否确认导出?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = Object.assign(
          {
            skuId: this.skuId,
            companyId: this.companyId,
            type: flg
          },
          this.filter
        )
        delete params.page
        delete params.limit
        this.$refs.FileExport.init(
          params, // 搜索表单参数
          'jsw-product-provider', // 后端对应业务线服务
          '/adm/userSku/exportAllQualifiedData', // 导出-对应的接口
          1, //  状态：0get、1post
          title + '.xlsx' //文件名称
        )
      })
    },
    // 批量颁发结业证
    async awardGraduation () {
      if (!this.checkIds.length) {
        this.$message.error('请选择数据');
        return false;
      }

      const params = this.checkIds.map(item => {
        return {
          userSkuId: item,
          companyId: this.companyId,
          skuId: this.skuId,
          type: 2
        }
      })
      const res = await awardQualifieds(params)
      let { code, message } = res;
      if (code !== 0) {
        this.$message.success(message);
        return
      }
      this.$message.success('颁发成功，请点击“查询”刷新列表数据!')
      this.getList();
    },
    // 全部颁发结业证
    awardGraduationAll () {
      this.$confirm('是否确认为当前班级所有学员颁发结业证?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        awardQualified({
          companyId: this.companyId,
          skuId: this.skuId,
          type: 2,
        }).then(({ code, message }) => {
          if (code === 0) {
            if (message !== 'success') {
              this.$message.success(message);
            } else {
              this.$message.success('颁发成功，请点击“查询”刷新列表数据!');
            }
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      })
    },
    //批量颁发
    plBf () {
      if (!this.checkIds.length) {
        this.$message.error('请选择数据');
        return false;
      }
      const params = this.checkIds.map(item => {
        return {
          userSkuId: item,
          companyId: this.companyId,
          skuId: this.skuId,
          type: 1
        }
      })
      console.log(params)
      awardQualifieds(params).then(res => {
        let { code, message } = res;
        if (code === 0) {
          if (message != 'success') {
            this.$message.success(message);
          } else {
            this.$message.success('颁发成功，请点击“查询”刷新列表数据!');
          }
          this.getList();
        } else {
          this.$message.error(message);
        }
      })
    },
    plBfAll () {
      const companyId = this.companyId
      this.$confirm('是否确认为当前班级所有学员颁发合格证?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        awardQualified({
          companyId,
          skuId: this.skuId,
          type: 1,
        }).then(({ code, message }) => {
          if (code === 0) {
            if (message != 'success') {
              this.$message.success(message);
            } else {
              this.$message.success('颁发成功，请点击“查询”刷新列表数据!');
            }
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      })
    },
    //批量删除
    deletepl () {
      if (!this.checkIds.length) {
        this.$message.error('请选择数据');
        return false;
      }
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delCertificate(this.checkIds).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success('成功');
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      })
    },
    deleteAllCer (flg) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (flg == '1') {
          delAllGraduation({
            id: this.skuId
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('成功');
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        } else {
          delAllCertificate({
            id: this.skuId
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('成功');
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        }
      })
    },
    async getCompanyList(){
      const res = await getAvailableCompanyList()
      this.companyList = res.data
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.studentsList.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  },
}
</script>
<style lang='scss' scoped>
.btns {
  margin: 10px 0;
}
.b-btns {
  button {
    margin: 10px;
  }
}

.page-students {
  background: #fff;
  padding: 20px;
  .students-search {
    margin-bottom: 20px;
    .search-label {
      margin-right: 10px;
    }
    .search-input {
      width: 230px;
      margin-right: 20px;
    }
    .search-but1 {
      margin-right: 10px;
    }
    .search-but2 {
      margin-right: 10px;
    }
  }
  .students-add {
    margin-bottom: 20px;
    text-align: right;
  }
  .students-table {
    margin-bottom: 20px;
    .table-img {
      width: 100px;
      height: 20px;
      cursor: pointer;
    }
  }
}
</style>
